import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { AwardOfContractComponent } from '../award-of-contract/award-of-contract.component';
import { IdexCommercialRfpComponent } from '../idex-commercial-rfp/idex-commercial-rfp.component';
import { PreliminaryDesignComponent } from '../preliminary-design/preliminary-design.component';
import { CriticalDesignComponent } from '../critical-design/critical-design.component';
import { IdexUtrrComponent } from '../idex-utrr/idex-utrr.component';
import { ProductionSupplyComponent } from '../production-supply/production-supply.component';
import { TotComponent } from '../tot/tot.component';
import { PrototypeDeliveryComponent } from '../prototype-delivery/prototype-delivery.component';
import { PreparationOfPsqrFrommPddComponent } from '../preparation-of-psqr-fromm-pdd/preparation-of-psqr-fromm-pdd.component';
import { SsctComponent } from '../ssct/ssct.component';
import { StaffEvaluationComponent } from '../staff-evaluation/staff-evaluation.component';
import { AONComponent } from '../stape-component/aon/aon.component';
import { ConstituteContractNegotiationCommitteeComponent } from '../constitute-contract-negotiation-committee/constitute-contract-negotiation-committee.component';
import { BanchmarkComponent } from '../stape-component/banchmark/banchmark.component';
import { IdexComponent } from '../idex/idex.component';
import { PreliminaryDiscussionComponent } from '../preliminary-discussion/preliminary-discussion.component';
import { FeasibiltyStudyComponent } from '../feasibilty-study/feasibilty-study.component';
import { ConcurrenceRfiComponent } from '../concurrence-rfi/concurrence-rfi.component';
import { DrdoAipComponent } from '../drdo-aip/drdo-aip.component';
import { FirmResponseSubmissionComponent } from '../firm-response-submission/firm-response-submission.component';
import { FirmResponseEvaluationComponent } from '../firm-response-evaluation/firm-response-evaluation.component';
import { CommercialEvaluationComponent } from '../stape-component/financial-evaluation/commercial-evaluation.component';
import { CommercialNegocatitionComponent } from '../stape-component/commercial-negocatition/commercial-negocatition.component';
import { ConstituteCommitteeComponent } from '../stape-component/constitute-committee/constitute-committee.component';
import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
import { Table } from 'primeng/table';
import { PddComponent } from '../pdd/pdd.component';
import { UploadHatSatComponent } from '../stape-component/upload-hat-sat/upload-hat-sat.component';
import { BulkProductionComponent } from '../bulk-production/bulk-production.component';
import { ProjectClosureComponent } from '../project-closure/project-closure.component';


@Component({
  selector: 'app-tdf-transaction',
  standalone: false,
  templateUrl: './tdf-transaction.component.html',
  styleUrl: './tdf-transaction.component.scss'
})
export class TdfTransactionComponent implements OnInit, OnDestroy {
  @ViewChild(AwardOfContractComponent) awardOfContractComponent?: AwardOfContractComponent;
  @ViewChild(IdexCommercialRfpComponent) idexCommercialRfpComponent?: IdexCommercialRfpComponent;
  @ViewChild(PreliminaryDesignComponent) preliminaryDesignComponent?: PreliminaryDesignComponent;
  @ViewChild(CriticalDesignComponent) criticalDesignComponent?: CriticalDesignComponent;
  @ViewChild(IdexUtrrComponent) idexUtrrComponent?: IdexUtrrComponent;
  @ViewChild(ProductionSupplyComponent) productionSupplyComponent?: ProductionSupplyComponent;
  @ViewChild(TotComponent) totComponent?: TotComponent;
  @ViewChild(PrototypeDeliveryComponent) prototypeDeliveryComponent?: PrototypeDeliveryComponent;
  @ViewChild(PreparationOfPsqrFrommPddComponent) preparationOfPsqrFrommPddComponent?: PreparationOfPsqrFrommPddComponent;
  @ViewChild(SsctComponent) ssctComponent?: SsctComponent;
  @ViewChild(StaffEvaluationComponent) staffEvaluationComponent?: StaffEvaluationComponent;
  @ViewChild(AONComponent) aonComponent?: AONComponent;
  @ViewChild(ConstituteContractNegotiationCommitteeComponent) constituteContractNegotiationCommitteeComponent?: ConstituteContractNegotiationCommitteeComponent;
  @ViewChild(BanchmarkComponent) banchmarkComponent?: BanchmarkComponent;
  @ViewChild(IdexComponent) idexComponent?: IdexComponent;
  @ViewChild(PreliminaryDiscussionComponent) preliminaryDiscussionComponent?: PreliminaryDiscussionComponent;
  @ViewChild(FeasibiltyStudyComponent) feasibiltyStudyComponent?: FeasibiltyStudyComponent;
  @ViewChild(ConcurrenceRfiComponent) concurrenceRfiComponent?: ConcurrenceRfiComponent;
  @ViewChild(DrdoAipComponent) drdoAipComponent?: DrdoAipComponent;
  @ViewChild(FirmResponseSubmissionComponent) firmResponseSubmissionComponent?: FirmResponseSubmissionComponent;
  @ViewChild(FirmResponseEvaluationComponent) firmResponseEvaluationComponent?: FirmResponseEvaluationComponent;
  @ViewChild(CommercialEvaluationComponent) commercialEvaluationComponent?: CommercialEvaluationComponent;
  @ViewChild(CommercialNegocatitionComponent) commercialNegocatitionComponent?: CommercialNegocatitionComponent;
  @ViewChild(ConstituteCommitteeComponent) constituteCommitteeComponent?: ConstituteCommitteeComponent;
  @ViewChild(TransHeaderSteperComponent) transHeaderSteperComponent?: TransHeaderSteperComponent;
  @ViewChild(UploadHatSatComponent) uploadHatSatComponent?: UploadHatSatComponent;
  @ViewChild(PddComponent) pddComponent?: PddComponent;
  @ViewChild('documentTable') documentTable?: Table;
  @ViewChild(BulkProductionComponent) bulkProduction?: BulkProductionComponent;
  @ViewChild(ProjectClosureComponent) projectClosure?: ProjectClosureComponent;
  role_id = sessionStorage.getItem('user_role_id');

  baseUrl = environment.APIUrl;
  masterData: any[] = [];
  pdfdata: any;
  DocName = '';
  displayDialog = false;
  proposalId!: number | string;
  proposalName = '';
  schemeId!: number | string;
  phaseId!: number | string;
  step_details: any;
  userGuide: string = 'process';
  reportList: any[] = [];
  documentList: any[] = [];
  searchText = '';
  tabList: any[] = [];
  confirmChecked = false;
  private subscriptions = new Subscription();

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    const paramsSub = this.route.queryParams.subscribe(params => {
      this.proposalId = params['id'];
      this.proposalName = params['name'] ?? '';
      this.phaseId = params['phase'];
      this.schemeId = params['scheme'];
    });
    this.subscriptions.add(paramsSub);
    this.fetchMasterData();
    this.fetchTabs();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getReportList(): void {
    if (!this.step_details?.id || !this.proposalId) return;
    this.reportList = [];
    const sub = this.api
      .getAPI(`/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.reportList = res || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch report versions.'
        })
      });
    this.subscriptions.add(sub);
  }

  getDocumentList(): void {
    if (!this.proposalId) return;
    this.documentList = [];
    const sub = this.api
      .getAPI(`/transaction/dms/files/?proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.documentList = res?.data || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch documents.'
        })
      });
    this.subscriptions.add(sub);
  }

  pdfconvert(htmlContent: string): void {
    if (!htmlContent) return;
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url; anchor.download = 'report.html'; anchor.click();
    window.URL.revokeObjectURL(url);
  }

  comment: string = '';
  submitIRA(): void {
    if (!this.step_details?.id) return;
    const payload = {
      editor_turn: this.step_details.editor_id,
      remarks: this.comment,
    };
    const sub = this.api.postAPI(`/file_mange/editor/approve/`, payload).subscribe(res => {


      if (res.status !== 'Approved') {

        this.transHeaderSteperComponent?.navigate(1, true);
      } else {
        this.transHeaderSteperComponent?.navigate(1, false, true);
      }
    }
    );
    this.subscriptions.add(sub);
  }

  generatePDF(event: any): void {
    this.pdfdata = event; this.displayDialog = true;
  }

  isHTMLorText(input: any): boolean {
    if (typeof input !== 'string') return false;
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }

  saveVersion(): void {
    const data = document.getElementById('printSection')?.innerHTML;
    if (!data || !this.step_details?.id || !this.pdfdata?.url) {
      console.error('Missing required data for saving version.');
      return;
    }
    const payload = {
      proposal_step: this.step_details.id,
      name: this.DocName || 'Version',
      paragraph: data
    };
    const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
      next: res => {
        this.DocName = '';
        this.messageService.add({
          severity: 'success', summary: 'Success', detail: res?.message || 'Version saved successfully.'
        });
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to save version.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchMasterData(): void {
    const sub = this.api.getAPI(`/master/master-data/`).subscribe({
      next: (res: any) => {
        const data = res?.data || [];
        this.masterData = data.map((item: any) => ({
          id: item.id,
          name: item.name,
          paragraph_1: item.paragraph_1,
          paragraph_2: item.paragraph_2,
          style: item.css_file_url,
          criteria_list: JSON.stringify(item.criteria_list, null, 2)
        }));
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch master data.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchTabs(): void {
    if (!this.schemeId) return;
    const sub = this.api.getAPI(`/master/scheme/${this.schemeId}/phases/`).subscribe({
      next: (res: any) => (this.tabList = res || []),
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch phases.'
      })
    });
    this.subscriptions.add(sub);
  }

  showConfirm(): void {
    this.messageService.clear('confirm');
    this.messageService.add({
      key: 'confirm',
      sticky: true,
      severity: 'info',
      summary: 'Are you sure you want to submit this proposal?'
    });
  }
  topRender = true;
  submitProposal(action: 1 | 2): void {
    this.awardOfContractComponent ? this.awardOfContractComponent?.onSubmit() : null;
    this.idexCommercialRfpComponent ? this.idexCommercialRfpComponent?.onRFPSubmit() : null;
    this.preliminaryDesignComponent ? this.preliminaryDesignComponent?.onSubmit() : null;
    this.criticalDesignComponent ? this.criticalDesignComponent?.onSubmit() : null;
    this.idexUtrrComponent ? this.idexUtrrComponent?.onJustificationSubmit() : null;
    this.productionSupplyComponent ? this.productionSupplyComponent?.onSubmit() : null;
    this.totComponent ? this.totComponent?.onSubmit() : null;
    this.prototypeDeliveryComponent ? this.prototypeDeliveryComponent?.onSubmit() : null;
    this.preparationOfPsqrFrommPddComponent ? this.preparationOfPsqrFrommPddComponent?.onSubmit() : null;
    this.ssctComponent ? this.ssctComponent?.onSubmit() : null;
    this.staffEvaluationComponent ? this.staffEvaluationComponent?.onSubmit() : null;
    this.aonComponent ? this.aonComponent?.onSubmit() : null;
    this.constituteContractNegotiationCommitteeComponent ? this.constituteContractNegotiationCommitteeComponent?.onSubmit() : null;
    this.banchmarkComponent ? this.banchmarkComponent?.submitProposalData() : null;
    this.idexComponent ? this.idexComponent?.onSubmit() : null;
    this.preliminaryDiscussionComponent ? this.preliminaryDiscussionComponent?.onSubmit() : null;
    this.feasibiltyStudyComponent ? this.feasibiltyStudyComponent?.onSubmit() : null;
    this.concurrenceRfiComponent ? this.concurrenceRfiComponent?.onSubmit() : null;
    this.drdoAipComponent ? this.drdoAipComponent?.onSubmit() : null;
    // this.firmResponseSubmissionComponent ? this.firmResponseSubmissionComponent?.onSubmit() : null;
    // this.firmResponseEvaluationComponent? this.firmResponseEvaluationComponent?.onSubmit() : null;
    this.pddComponent ? this.pddComponent?.onSubmit() : null;
    this.uploadHatSatComponent ? this.uploadHatSatComponent?.onSubmit() : null;
    this.commercialEvaluationComponent ? this.commercialEvaluationComponent?.onSubmit() : null;
    this.commercialNegocatitionComponent ? this.commercialNegocatitionComponent?.onSubmit() : null;
    this.constituteCommitteeComponent ? this.constituteCommitteeComponent?.onSubmit() : null;
    this.bulkProduction ? this.bulkProduction?.onSubmit() : null;
    this.projectClosure ? this.projectClosure?.onSubmit() : null;
    this.messageService.clear('confirm');
    if (action === 2) {
      this.submitIRA();

    }
  }


  checkIsNextRouteConfig() {
    const t = this.api.getData() || [];


    // current working directorate (top level)
    const currentIndex = t.findIndex(s => (s?.status ?? "") === "working");
    if (currentIndex === -1) return false;

    // 1) current directorate ke internalUsers me (current working user ke baad) koi edit hai kya?
    const curr = t[currentIndex];
    if (curr?.hasInternal && Array.isArray(curr.internalUsers) && curr.internalUsers.length) {
      const internalIndex = curr.internalUsers.findIndex(u => (u?.status ?? "") === "working");

      if (internalIndex !== -1) {
        const hasNextInternalEdit = curr.internalUsers
          .slice(internalIndex + 1)
          .some(u => (u?.permission ?? "") === "edit");

        if (hasNextInternalEdit) return true;
      } else {
        // Agar koi internal "working" marked hi nahi hai, still check any internal edit
        if (curr.internalUsers.some(u => (u?.permission ?? "") === "edit")) return true;
      }
    }

    // 2) currentIndex ke baad ke sabhi next directorates + unke internalUsers me koi edit hai kya?
    for (let i = currentIndex + 1; i < t.length; i++) {
      const next = t[i];

      // next directorate itself has edit
      if ((next?.permission ?? "") === "edit") return true;

      // next directorate ke kisi bhi internal user ke paas edit
      if (next?.hasInternal && Array.isArray(next.internalUsers) && next.internalUsers.length) {
        const anyInternalEdit = next.internalUsers.some(u => (u?.permission ?? "") === "edit");
        if (anyInternalEdit) return true;
      }
    }

    return false;
  }
  trigarFromChild(): void {
    this.messageService.clear('confirm');
    this.transHeaderSteperComponent?.openDialog();
    this.transHeaderSteperComponent?.giveTheRouteconfigAccess();
  }
  currentStepChange(event: any): void {
    this.step_details = event;
  }

  apiResponse: any;
  getReportData(): void {
    this.api.getAPI(`/tdf/proposal/report/${this.proposalId}/`).subscribe((res) => {
      this.apiResponse = res;
    });
  }
}
